module.exports = __webpack_public_path__ + "img/clock.56fa14b5.png";